/* Floretti 3.0 — header-gedrag: mega-dropdown, mobiel menu, thematoggle.
   Als custom element opgezet zodat de theme-editor de sectie kan herladen
   zonder dubbele listeners. */
(function () {
  'use strict';

  var STORAGE_KEY = 'floretti-theme';

  class FlorettiHeader extends HTMLElement {
    connectedCallback() {
      this.dropdowns = Array.prototype.slice.call(this.querySelectorAll('[data-nav-dropdown]'));
      this.nav = this.querySelector('[data-primary-nav]');
      this.mobileToggle = this.querySelector('[data-mobile-toggle]');
      this.themeToggle = this.querySelector('[data-theme-toggle]');

      this._onDocumentClick = this.handleDocumentClick.bind(this);
      this._onKeydown = this.handleKeydown.bind(this);

      this.bindDropdowns();
      this.bindMobileMenu();
      this.bindThemeToggle();

      document.addEventListener('click', this._onDocumentClick);
      document.addEventListener('keydown', this._onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDocumentClick);
      document.removeEventListener('keydown', this._onKeydown);
      if (this._headerObserver) this._headerObserver.disconnect();
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      /* De theme-editor haalt secties weg terwijl het menu open kan staan.
         Zonder dit blijft <html> vergrendeld achter en scrollt de pagina niet. */
      document.documentElement.classList.remove('floretti-menu-open');
      document.body.style.overflow = '';
    }

    /* ---------- Mega-dropdown ---------- */
    bindDropdowns() {
      var self = this;
      this.dropdowns.forEach(function (dropdown) {
        var trigger = dropdown.querySelector('[data-nav-dropdown-trigger]');
        if (!trigger) return;
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var willOpen = !dropdown.classList.contains('is-open');
          self.closeAllDropdowns();
          if (willOpen) self.openDropdown(dropdown);
        });
      });
    }

    openDropdown(dropdown) {
      dropdown.classList.add('is-open');
      var trigger = dropdown.querySelector('[data-nav-dropdown-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    closeAllDropdowns() {
      this.dropdowns.forEach(function (dropdown) {
        dropdown.classList.remove('is-open');
        var trigger = dropdown.querySelector('[data-nav-dropdown-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    handleDocumentClick(event) {
      if (this.contains(event.target)) return;
      this.closeAllDropdowns();
    }

    handleKeydown(event) {
      if (event.key !== 'Escape') return;
      this.closeAllDropdowns();
      this.closeMobileMenu();
    }

    /* ---------- Mobiel menu ---------- */
    bindMobileMenu() {
      if (!this.mobileToggle || !this.nav) return;
      var self = this;
      this.mobileToggle.addEventListener('click', function () {
        var isOpen = self.nav.classList.toggle('is-open');
        self.setMenuState(isOpen);
        if (!isOpen) self.closeAllDropdowns();
      });

      /* De hoogte van de header bepaalt waar het paneel begint. Meten is
         betrouwbaarder dan een vast getal: bij grotere systeemletters groeit
         de header mee en zou een hardgecodeerde offset een kier laten. */
      this.syncHeaderHeight();
      if ('ResizeObserver' in window) {
        this._headerObserver = new ResizeObserver(this.syncHeaderHeight.bind(this));
        this._headerObserver.observe(this);
      } else {
        this._onResize = this.syncHeaderHeight.bind(this);
        window.addEventListener('resize', this._onResize);
      }
    }

    syncHeaderHeight() {
      var hoogte = this.getBoundingClientRect().height;
      if (hoogte > 0) {
        document.documentElement.style.setProperty('--floretti-header-h', hoogte + 'px');
      }
    }

    /* De klasse op <html> doet twee dingen die niet vanuit de header zelf
       kunnen: hij zet de backdrop-filter uit — die maakt de header anders het
       containing block voor het fixed paneel — en tilt de sectiewrapper boven
       de rest van de pagina uit. Zie section-floretti-header.css. */
    setMenuState(isOpen) {
      if (this.mobileToggle) this.mobileToggle.setAttribute('aria-expanded', String(isOpen));
      document.documentElement.classList.toggle('floretti-menu-open', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    }

    closeMobileMenu() {
      if (!this.nav || !this.nav.classList.contains('is-open')) return;
      this.nav.classList.remove('is-open');
      this.setMenuState(false);
    }

    /* ---------- Licht / donker ---------- */
    bindThemeToggle() {
      if (!this.themeToggle) return;
      var self = this;
      this.syncThemeToggle();
      this.themeToggle.addEventListener('click', function () {
        var next = document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', next);
        try {
          localStorage.setItem(STORAGE_KEY, next);
        } catch (e) {
          /* private mode — thema geldt dan alleen deze sessie */
        }
        self.syncThemeToggle();
      });
    }

    syncThemeToggle() {
      var isDark = document.documentElement.getAttribute('data-theme') === 'dark';
      var icon = this.themeToggle.querySelector('[data-theme-icon]');
      if (icon) icon.textContent = isDark ? '☀️' : '🌙';
      this.themeToggle.setAttribute('aria-pressed', String(isDark));
      this.themeToggle.setAttribute(
        'aria-label',
        isDark ? this.themeToggle.dataset.labelLight : this.themeToggle.dataset.labelDark
      );
    }
  }

  if (!customElements.get('floretti-header')) {
    customElements.define('floretti-header', FlorettiHeader);
  }
})();
